import {useCanvasDispatch, useCanvasState} from "../../../context/canvas/CanvasContext";
import React, {useState} from "react";
import {useProjectState} from "../../../context/project/ProjectIndex";
import {CanvasActions} from "./CanvasActions";
import {addCanvasObject} from "../../../context/canvas/CanvasActions";
import {useApiErrorDispatch} from "../../../context/api_error/ApiErrorIndex";
import AIImageModal from "../../AIImage/AIImageModal";
import {ReactComponent as Logo} from './../../../assets/image-ia.svg';
import {UncontrolledTooltip} from "reactstrap";

export const CanvasTemplateObjectAddActions = () => {
  const [showAIImageModal, setShowAIImageModal] = useState(false);
  const canvasDispatch = useCanvasDispatch()
  const apiErrorDispatch = useApiErrorDispatch()

  const canvasState = useCanvasState();
  const projectState = useProjectState()

  const handleAddClick = (type) => {
    addCanvasObject(canvasDispatch, type);
  }

  const handleAIImageClick = () => {
    setShowAIImageModal(true);
  }

  const handleCloseAIImageModal = () => {
    setShowAIImageModal(false);
  }

  return (<>
    <div className={'bg-white d-flex flex-column order-1 align-items-center'}>
      <CanvasActions
        companyId={projectState.companyId}
        projectId={projectState.projectId}
        id={canvasState.template.id}
      />
      <div id="image-object" className={'canvas_actions pt-4 pb-2 cursor-pointer'}
           onClick={() => handleAddClick('image')}>
        <span className="fa fa-2x fa-image text-primary"/>
        <UncontrolledTooltip placement="right" target="image-object">
          Add Image
        </UncontrolledTooltip>
      </div>
      <div id="text-object" className={'canvas_actions py-2 cursor-pointer'}
           onClick={() => handleAddClick('text_object')}>
        <span className="fa fa-2x fa-font text-primary"/>
        <UncontrolledTooltip placement="right" target="text-object">
          Add Text
        </UncontrolledTooltip>
      </div>
      <div id="two-prices-object" className={'canvas_actions py-2 cursor-pointer'}
           onClick={() => handleAddClick('two_prices_object')}>
        <span className="fa fa-2x fa-tags text-primary"/>
        <UncontrolledTooltip placement="right" target="two-prices-object">
          Add Price
        </UncontrolledTooltip>
      </div>
      <div className={'canvas_actions py-2 cursor-pointer'} onClick={handleAIImageClick}>
        <Logo id={"ai-image"} width="36px" height="36px"/>
        <UncontrolledTooltip placement="right" target="ai-image">
          Generate AI Image
        </UncontrolledTooltip>
      </div>
    </div>

    {showAIImageModal && (
      <AIImageModal
        isOpen={showAIImageModal}
        onClose={handleCloseAIImageModal}
        companyId={projectState.companyId}
        projectId={projectState.projectId}
        canvasDispatch={canvasDispatch}
      />
    )}
  </>)
}
